exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-basic-search[data-v-b0e531aa]{justify-content:center;align-items:center;display:flex}@media only screen and (max-width:1024px){.region-label[data-v-b0e531aa]{width:50px}}", ""]);

// exports
